import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ConversationInterface } from "../../Entity/Entities/Conversation/ConversationInterface";
import ConversationFactory from "../../Entity/Factories/ConversationFactory";

export default function* conversationReadUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_REQUEST
    });

    const res = yield call(Http.patch, `conversations/${action?.payload?.conversationId}/read`, {
      ...action.payload?.conversation
    });

    const conversation: ConversationInterface = ConversationFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CONVERSATIONS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, conversation);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchConversationReadUpdate() {
  yield takeEvery(Constants.GLOBAL_CONVERSATION_READ_UPDATE_START, conversationReadUpdate);
}